(function () {
  const settingsEl = document.getElementById('GiftPromoSettings');
  if (!settingsEl) return;

  const IS_ACTIVE = settingsEl.dataset.active === 'true';
  const VARIANT_ID = Number(settingsEl.dataset.variantId);
  const QUANTITY = Number(settingsEl.dataset.quantity) || 1;
  const GIFT_PROPERTY_KEY = settingsEl.dataset.propertyKey || '_free_gift';

  if (!IS_ACTIVE || !VARIANT_ID) return;

  const routes = window.routes || {};
  const cartUrl = routes.cart_url || '/cart';
  const addUrl = routes.cart_add_url || '/cart/add';
  const changeUrl = routes.cart_change_url || '/cart/change';

  const SOURCE = 'gift-promo';
  let isSyncing = false;
  let resyncQueued = false;
  let resyncAllowAdd = false;

  function getCart() {
    return fetch(`${cartUrl}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
  }

  function sectionsToRequest() {
    const ids = [];
    if (document.getElementById('cart-icon-bubble')) ids.push('cart-icon-bubble');
    if (document.querySelector('cart-drawer')) ids.push('cart-drawer');
    if (document.querySelector('cart-notification')) ids.push('cart-notification');
    if (document.getElementById('main-cart-items')) ids.push('main-cart-items');
    if (document.getElementById('main-cart-footer')) ids.push('main-cart-footer');
    if (document.getElementById('cart-live-region-text')) ids.push('cart-live-region-text');
    return ids;
  }

  function postCart(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    }).then((r) => r.json());
  }

  function addGift(sections) {
    return postCart(addUrl, {
      items: [
        {
          id: VARIANT_ID,
          quantity: QUANTITY,
          properties: { [GIFT_PROPERTY_KEY]: 'true' },
        },
      ],
      sections,
      sections_url: window.location.pathname,
    });
  }

  function changeGift(key, quantity, sections) {
    return postCart(changeUrl, {
      id: key,
      quantity,
      sections,
      sections_url: window.location.pathname,
    });
  }

  function getSectionInnerHTML(html, selector) {
    const node = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return node ? node.innerHTML : null;
  }

  function updateCartBubble(itemCount) {
    if (typeof itemCount !== 'number') return;
    document.querySelectorAll('.cart-counter').forEach((counter) => {
      counter.textContent = itemCount > 0 ? `(${itemCount})` : '';
    });
  }

  function renderSections(sections) {
    if (!sections) return;

    const targets = [
      { sectionId: 'cart-icon-bubble', elementId: 'cart-icon-bubble', selector: '.shopify-section' },
      { sectionId: 'cart-drawer', elementId: 'CartDrawer', selector: '.drawer__inner' },
      { sectionId: 'main-cart-items', elementId: 'main-cart-items', selector: '.js-contents' },
      { sectionId: 'main-cart-footer', elementId: 'main-cart-footer', selector: '.js-contents' },
      { sectionId: 'cart-live-region-text', elementId: 'cart-live-region-text', selector: '.shopify-section' },
    ];

    targets.forEach((t) => {
      const html = sections[t.sectionId];
      const container = document.getElementById(t.elementId);
      if (!html || !container) return;
      const target = container.querySelector(t.selector) || container;
      const newHTML = getSectionInnerHTML(html, t.selector);
      if (newHTML !== null) target.innerHTML = newHTML;
    });

    const itemCount = sections.__itemCount;
    if (typeof itemCount === 'number') {
      const drawer = document.querySelector('cart-drawer');
      const cartFooter = document.getElementById('main-cart-footer');
      if (drawer) drawer.classList.toggle('is-empty', itemCount === 0);
      if (cartFooter) cartFooter.classList.toggle('is-empty', itemCount === 0);
      document
        .querySelectorAll('cart-items, cart-drawer-items')
        .forEach((el) => el.classList.toggle('is-empty', itemCount === 0));
    }
  }

  async function sync(allowAdd) {
    if (isSyncing) {
      resyncQueued = true;
      resyncAllowAdd = resyncAllowAdd || !!allowAdd;
      return;
    }
    isSyncing = true;

    try {
      const cart = await getCart();
      const items = (cart && cart.items) || [];
      const giftLine = items.find((item) => item.variant_id === VARIANT_ID);
      const hasRegularItem = items.some((item) => item.variant_id !== VARIANT_ID);
      const sections = sectionsToRequest();

      let response = null;

      if (giftLine && !hasRegularItem) {
        response = await changeGift(giftLine.key, 0, sections);
      } else if (allowAdd && hasRegularItem && !giftLine) {
        response = await addGift(sections);
        if (response && response.status && response.status !== 200) {
          console.warn('[gift-promo] could not add gift:', response.description || response.message);
          response = null;
        }
      } else if (giftLine && hasRegularItem && giftLine.quantity !== QUANTITY) {
        response = await changeGift(giftLine.key, QUANTITY, sections);
      }

      if (response && response.sections) {
        const freshCart = await getCart();
        const itemCount = freshCart && typeof freshCart.item_count === 'number' ? freshCart.item_count : null;
        if (itemCount !== null) response.sections.__itemCount = itemCount;
        renderSections(response.sections);
        updateCartBubble(itemCount);

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && freshCart) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: SOURCE, cartData: freshCart });
        }
      }
    } catch (e) {
      console.error('[gift-promo] sync failed:', e);
    } finally {
      isSyncing = false;
      if (resyncQueued) {
        resyncQueued = false;
        const allowAddNext = resyncAllowAdd;
        resyncAllowAdd = false;
        sync(allowAddNext);
      }
    }
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event && event.source === SOURCE) return;
      const allowAdd = !!(event && event.source && event.source !== 'cart-items');
      sync(allowAdd);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => sync(false), { once: true });
  } else {
    sync(false);
  }
})();
